<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <WorkPackageLarge :color="getWP1.color" class="comparison-wp">
          <template #head>
            <WorkPackageLargeHead
              :work_packages="[getWP1]"
              :selected_id="getWP1.id">
              <template #name><small>{{getWP1.name}}</small></template>
            </WorkPackageLargeHead>
          </template>
          <template #body>
            <v-row>
              <v-col cols="1"></v-col>
              <v-col cols="10">
                <draggable
                :value="getWP1.work_steps"
                @change="pushWorkStepAI($event)"
                v-bind="work_step_draggable">
                  <v-row v-for="(tws_1, index) in getWP1.work_steps"
                  :key="tws_1.id">
                    <v-col cols="10">
                      <StandardTextfield
                      :color="`${getWP1.color} lighten-2`"
                      icon="radio_button_unchecked"
                      type="text"
                      class="mb-2"
                      style="width: 100%"
                      :readonly="false"
                      :value="tws_1.text"
                      @changeValue="updateWorkStepAI({index: index, text: $event})" />
                    </v-col>
                    <v-col cols="2">
                      <v-btn small color="red" @click="deleteWorkStepAI(index)">{{$t('Buttons.Delete')}}</v-btn>
                    </v-col>
                  </v-row>
                </draggable>
                <v-row>
                  <v-col cols="10">
                    <StandardTextfield
                      :color="`${getWP1.color} lighten-2`"
                      icon="radio_button_unchecked"
                      type="text"
                      class="mb-2"
                      style="width: 100%"
                      :readonly="false"
                      placeholder="Add a new Work Step"
                      :value="new_ws"
                      :key="new_ws_update"
                      @changeValue="addWorkStep($event)" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </template>
        </WorkPackageLarge>
      </v-col>
      <v-col cols="6">
        <v-btn large color="green" @click="createCompleteWorkPackageAI(getWP1)">{{$t('AiDashboard.Country.Create')}}</v-btn>
        <br> <br>
        <v-btn large color="grey" @click="getTwoRandomWPs()">{{$t('AiDashboard.Discard')}}</v-btn>

      </v-col>
    </v-row>
    <!-- <v-row justify="center">
      <v-col cols="1">
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import draggable from "vuedraggable"
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import WorkPackageLarge from '@/components/WorkPackages/WorkPackageLarge.component.vue';
import WorkPackageLargeHead from '@/components/WorkPackages/WorkPackageLargeHead.component.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'WPCountry',
  components: {
    draggable,
    StandardTextfield,
    WorkPackageLarge,
    WorkPackageLargeHead
  },
  data: function () {
    return {
      new_ws: '',
      new_ws_update: 0,
      work_step_draggable: {
        group: {
          name: 'draggable_work_steps',
          pull: true,
          put: true
        }
      }
    }
  },
  created(){
    this.getTwoRandomWPs();
  },
  computed: {
    ...mapGetters('AI', [
      'getWP1',
      'getWP2'
    ])
  },
  methods: {
    ...mapActions('AI', [
      'getTwoRandomWPs',
      'createCompleteWorkPackageAI',
      'updateWorkStepAI',
      'deleteWorkStepAI',
      'addWorkStepAI',
      'pushWorkStepAI'
    ]),
    addWorkStep(text){
      this.new_ws = '';
      this.new_ws_update++;
      this.addWorkStepAI(text);
    }
  }
}
</script>

<style lang="css" scoped>
.comparison-wp {
  height: 600px;
  overflow-y: auto;
}
.flag-wrapper {
  height: 64px;
  width: 64px;
}
</style>
